import { InlineValuePopover } from "@xola/ui-kit";
import { formatAMPM, parseTime } from "common/src/helpers/dateHelper";
import React from "react";
import { useVisibility } from "../../../../hooks/useVisibility";
import { Hour, TimePicker } from "../../../PurchaseModification/TimeslotTimePicker";

interface TimeslotInlinePopoverProps {
    value: number | null;
    onChange: (value: number) => void;
}

export const InlineTimeslotPicker = ({ value = 0, onChange }: TimeslotInlinePopoverProps) => {
    const time = value === null ? null : parseTime(value);
    const [isOpen, { toggle, hide }] = useVisibility(false);

    const handleMinuteClick = (minute: number) => {
        const value = (time?.hours ?? 0) * 100 + minute;
        onChange(value);
    };

    const handleHourClick = (hour: Hour) => {
        const formattedMinutes = time?.minutes ?? 0;
        const formattedTime = hour.metric * 100 + formattedMinutes;

        onChange(formattedTime);
    };

    return (
        <InlineValuePopover
            showArrow
            text={formatAMPM(parseTime(value ?? 300))}
            isOpen={isOpen}
            classNames={{ text: "px-0.5 pb-0.5 ml-1 text-black" }}
            maxWidth="800px"
            onClick={toggle}
            onClickOutside={hide}
        >
            <div className="flex space-y-2 p-4">
                <TimePicker time={time} onHourClick={handleHourClick} onMinuteClick={handleMinuteClick} />
            </div>
        </InlineValuePopover>
    );
};
